module.exports = __webpack_public_path__ + "img/produkt-celer.356ad232.jpg";